import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { Empresa } from '../interfaces/empresa.interface';
import { DireccionUrbana } from '../interfaces/direccionUrbana.interface';
import { EmpresaService } from '../services/empresa.service';
import { catchError } from 'rxjs/operators';
import { DirUrbanaComponent } from '../dir-urbana/dir-urbana.component';

import { opciones } from '../assets/dataEslabon';
import { KeycloakService } from 'keycloak-angular';
import { EmpresaHelperService } from '../services/editar-empresa-helper.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { RegistroService } from 'src/app/registro.service';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ENUM_ESTADO_REGISTRO } from 'src/app/common/enums/app.enum';
import { etiquetaProducto } from '../utils/etiquetas-producto.util';

@Component({
    selector: 'app-empresa-formulario',
    templateUrl: './empresa.component.html',
    styleUrls: [
        './empresa.component.css',
        './../../components/view-succes/view-succes.component.css',
    ],
})
export class EmpresaComponent implements OnInit {
    nitInputVisible = false;
    empresaForm: FormGroup;
    empresa: Empresa;
    direccionUrbanahijo: DireccionUrbana;
    nitRef = new FormControl('');
    empresas: Empresa[];
    withoutFinding = false;
    asociarView = true;
    departamentos;
    cargos;
    opciones = opciones;
    userAgent;
    errorNitExist = false;
    accessToken = '';
    selectedProductos: string[] = [];
    selectedEslabon: string[] = [];
    isSubmitting = false;
    opcionesProducto: string[] = ['Alimentos balanceados', 'Agroinsumos'];
    etiquetaProducto = etiquetaProducto;
    opcionesEslabon = [
        'Productor',
        'Importador',
        'Comercializador',
        'Empacador',
        'Envasador',
    ];
    @ViewChild('dirUrbana', { static: false }) dirUrbana: DirUrbanaComponent;
    perfilUsuario;

    constructor(
        private fb: FormBuilder,
        private empresaService: EmpresaService,
        private registroService: RegistroService,
        private keycloakService: KeycloakService,
        private empresaHelper: EmpresaHelperService,
        private router: Router,
        @Inject(DOCUMENT) private document: Document,
        private translate: TranslateService
    ) {
        this.translate.setDefaultLang('es');
        this.translate.use('es');
        this.empresaService.getDepartamentos().subscribe((departamento) => {
            this.departamentos = departamento;
        });
        this.empresaService.getCargos().subscribe((cargo) => {
            this.cargos = cargo;
        });
    }
    /* Inicializacion formulario */
    ngOnInit() {
        this.empresaHelper.reset();
        this.selectedProductos = [];
        this.selectedEslabon = [];
        this.empresaForm = this.fb.group({
            tipoEmpresa: ['', [Validators.required]],
            tipo_producto_que_importa: ['', [Validators.required]],
            eslabon: ['', [Validators.required]],
            nit: [
                '',
                [Validators.required, Validators.pattern(/^[0-9]{6,10}$/)],
            ],
            digito_verificacion: [
                '',
                [Validators.required, Validators.pattern(/^[0-9]{1}$/)],
            ],
            razonSocial: ['', [Validators.required]],
            departamento: ['', [Validators.required]],
            telefono: [
                '',
                [Validators.required, Validators.pattern(/^[0-9]{10}$/)],
            ],
            celular: [''],
            correo_corporativo: ['', [Validators.required, Validators.email]],
            responsableInformacion: ['', [Validators.required]],
            cargoDependencia: ['', [Validators.required]],

            direccion: this.fb.group({
                municipioId: [''],
                zona: [''],
                complemento: [''],
                viaPrincipalTipo: [''],
                viaPrincipalNumero: [''],
                viaPrincipalLetra: [''],
                prefijoBis: [false],
                letraPrefijo: [''],
                viaPrincipalCuadrante: [''],
                viaGeneradoraNumero: [''],
                viaGeneradoraLetra: [''],
                numeroPlaca: [''],
                viaGeneradoraCuadrante: [''],
            }),
        });
        this.translate
            .get('empresa.alertaIngreso')
            .subscribe((translatedText: string) => {
                Swal.fire('', translatedText, 'info');
            });
    }

    /* funcion para interpolar el buscador informacion del nit  */
    changeSearch() {
        this.nitInputVisible = this.nitRef.value === '';
        if (this.nitInputVisible) {
            this.nitRef.setValue('');
            this.empresaForm.disable();
            this.dirUrbana.formDisable();
            this.asociarView = false;
        } else {
            this.empresaForm.reset();
            this.dirUrbana.clearForm();
            this.empresaForm.enable();
            this.dirUrbana.formActive();
            this.asociarView = true;
            this.withoutFinding = false;
        }
    }

    /**
     * Establece el valor del control 'tipoEmpresa' en el formulario reactivo.
     *
     * Este método se invoca desde la plantilla HTML, generalmente al hacer clic en un botón,
     * para asignar el tipo de empresa ('Natural' o 'Juridica') al `FormGroup`.
     * También marca el control como 'touched' para activar las validaciones y mostrar
     * los mensajes de error correspondientes si el usuario interactúa con el campo.
     *
     * @param {string} tipo El valor del tipo de empresa a establecer en el formulario.
     * @returns {void} Esta función no retorna ningún valor.
     */
    seleccionarTipoEmpresa(tipo: string): void {
        this.empresaForm.get('tipoEmpresa')?.setValue(tipo);
        this.empresaForm.get('tipoEmpresa')?.markAsTouched();
    }

    /* funcion para buscar la empresa e imprimirla en el formulario */
    getCompany() {
        const nit = this.nitRef.value;
        if (nit === '') {
            return;
        }
        this.empresaService
            .getEmpresaByNit(nit)
            .pipe(
                catchError((error) => {
                    this.withoutFinding = true;
                    this.empresaForm.reset();
                    this.dirUrbana.clearForm();
                    console.error('Error al buscar la empresa:', error);
                    return [];
                })
            )
            .subscribe((empresa) => {
                if (empresa) {
                    this.updateFormWithEmpresaData(empresa);
                    this.withoutFinding = false;
                } else {
                    this.withoutFinding = true;
                    console.log('Empresa no encontrada');
                }
            });
    }

    /** Muestra el formulario con la empresa encontrada solo si esta está activa
     * de lo contrario muestra una alerta y no carga los datos en el formulario.
     */
    updateFormWithEmpresaData(empresa: Empresa) {
        if (empresa.estado !== ENUM_ESTADO_REGISTRO.ACTIVO) {
            Swal.fire({
                icon: 'error',
                title: 'Error de validación',
                text: 'La empresa se encuentra inactiva, por favor comunícate a la mesa de ayuda de Siriiagro.',
                confirmButtonText: 'Entendido',
            });
            return;
        }
        this.empresaForm.reset();
        this.dirUrbana.clearForm();
        this.empresa = empresa;

        const departamento: string = empresa.direccion.municipio.departamentoId;
        this.selectedEslabon = this.empresa.eslabon.split('/');
        this.selectedProductos =
            this.empresa.tipo_producto_que_importa.split(' y ');
        this.empresaForm.patchValue(this.empresa);

        this.empresaForm.get('departamento').patchValue(departamento);
        this.dirUrbana.getMunicipio(departamento);
        this.dirUrbana.mostrarDirForm(empresa);
    }

    onDireccionUrbanaChanged(nuevosDatos: DireccionUrbana) {
        this.direccionUrbanahijo = nuevosDatos;
    }

    /**
     * Convierte el texto de un campo de formulario a mayúsculas en tiempo real.
     *
     * Este método se enlaza al evento `(input)` de un elemento `<input>`.
     * Captura el valor actual, lo transforma a mayúsculas y actualiza el
     * `FormControl` correspondiente. Para mejorar la experiencia de usuario,
     * restaura la posición del cursor después de la transformación.
     * Utiliza `{ emitEvent: false }` para evitar disparar eventos `valueChanges`
     * y prevenir ciclos de actualización no deseados.
     *
     * @param {Event} event El evento de entrada (input) del DOM, que contiene el elemento target.
     * @param {string} controlName El nombre del control del formulario (`FormControlName`) que se va a actualizar.
     * @returns {void} No retorna ningún valor.
     */
    toUpperCase(event: Event, controlName: string) {
        const input = event.target as HTMLInputElement;
        const start = input.selectionStart;
        const end = input.selectionEnd;
        const value = input.value.toUpperCase();
        this.empresaForm.get(controlName).setValue(value, { emitEvent: false });
        input.setSelectionRange(start, end);
    }

    updateMunicipio() {
        const idDepar = this.empresaForm.get('departamento').value;
        this.dirUrbana.getMunicipio(idDepar);
    }

    /**
     * Retorna true cuando el eslabón seleccionado es:
     * - Solo "Comercializador", o
     * - "Comercializador" combinado con "Empacador" y/o "Envasador",
     */
    private shouldNavigateToComercializador(): boolean {
        const sel = this.selectedEslabon || [];
        const tieneCom = sel.includes('Comercializador');
        const tieneProdOImp =
            sel.includes('Productor') || sel.includes('Importador');
        return tieneCom && !tieneProdOImp;
    }

    /**
     * Gestiona el envío del formulario para crear una empresa. Valida los datos,
     * incluido el correo del usuario. que no sea el mismo de la empresa
     * Tambien valida si el nit ya existe en la base de datos
     * Si el eslabón es 'Comercializador',
     * redirige a un flujo de caracterización; de lo contrario, procede con la
     * creación estándar de la empresa y su histórico.
     */
    async postEmpresa(nuevaEmpresa: Empresa) {
        this.perfilUsuario = await this.keycloakService.loadUserProfile();
        const perfilCargo = this.perfilUsuario.attributes.cargo[0];
        const email = nuevaEmpresa.correo_corporativo;

        if (email == this.perfilUsuario.email) {
            this.translate
                .get('empresa.validarCorreo')
                .subscribe((translatedText: string) => {
                    Swal.fire({
                        title: 'Información',
                        text: translatedText,
                        icon: 'info',
                        confirmButtonText: 'Continuar',
                    });
                });
            this.isSubmitting = false;
            return;
        }

        if (this.shouldNavigateToComercializador()) {
            try {
                this.isSubmitting = true;
                await firstValueFrom(
                    this.empresaService.checkNit(nuevaEmpresa.nit)
                );
                const translatedText = await firstValueFrom(
                    this.translate.get(
                        'empresa.alertaCaracterizacionComercializador'
                    )
                );

                await Swal.fire({
                    title: 'Información',
                    text: translatedText,
                    icon: 'info',
                    confirmButtonText: 'Continuar',
                });

                this.router.navigate(['/comercializador'], {
                    state: {
                        empresaData: nuevaEmpresa,
                        perfilCargo,
                        pendingEmpresaCreation: true,
                    },
                });
            } catch (err: any) {
                console.error('Ocurrió un error al validar el NIT:', err);
                const errorMessage = err?.error?.message || 'El nit ya existe.';
                this.errorNitExist = err?.status === 409;

                await Swal.fire({
                    icon: 'error',
                    title: 'Error de validación',
                    text: errorMessage,
                    confirmButtonText: 'Entendido',
                });
            } finally {
                this.isSubmitting = false;
            }
            return;
        }

        try {
            const response = await this.empresaService.crearEmpresaConHistorico(
                nuevaEmpresa,
                perfilCargo
            );
            //Se comenta el código porque esta es una solicitud de asociación de empresa
            //que esta en espera de aprobación.
            // this.registroService.empresasAsociadas = true;

            const translatedText = await firstValueFrom(
                this.translate.get('empresa.alertaExitosa')
            );

            await Swal.fire('', translatedText, 'success');

            this.router.navigate(['/inicio'], { state: { id: response.id } });
            this.empresaForm.reset();
            this.dirUrbana.clearForm();
            this.errorNitExist = false;
        } catch (error: any) {
            console.error('Error completo:', error);

            if (
                error.status === 409 &&
                error.error?.message ===
                    'El NIT proporcionado ya existe en la base de datos.'
            ) {
                this.errorNitExist = true;
                await Swal.fire(
                    '',
                    'El NIT proporcionado ya existe en la base de datos.',
                    'error'
                );
            } else {
                await Swal.fire(
                    '',
                    error.error?.message ||
                        'Ocurrió un error al crear la empresa. Intente nuevamente.',
                    'error'
                );
            }
        }
    }

    async asociarEmpresa() {
        try {
            this.perfilUsuario = await this.keycloakService.loadUserProfile();
            if (this.nitRef.value !== '' && this.withoutFinding === false) {
                const empresa = this.empresa;
                await this.empresaService.asociarAgenteVigilado(
                    empresa,
                    this.perfilUsuario.attributes.cargo[0]
                );

                const translated = await firstValueFrom(
                    this.translate.get('empresa.alertaExitosa')
                );
                await Swal.fire('', translated, 'info');
                window.scrollTo(0, 0);
                this.router.navigate(['/inicio']);

                //Swal.fire('', 'Esta empresa, ya tiene un representante activo. Contacta a la mesa de ayuda de Sirii<strong>agro</strong>, para más información.', 'error');
            }
            /**this.perfilUsuario = await this.keycloakService.loadUserProfile();
        if (this.nitRef.value !== "" && this.withoutFinding === false) {
          const empresa = this.empresa;
          await this.empresaservise.asociarAgenteVigilado(
            empresa,
            this.perfilUsuario.attributes.cargo[0],
            this.perfilUsuario.id
          );

          Swal.fire(
            'Solicitud enviada',
            'Se ha notificado a la empresa del intento de traspaso del representante. Estar atentos a cualquier novedad.',
            'info'
          )
        };**/
        } catch (error) {
            console.error('Error:', error);
            if (error?.status == 409) {
                await Swal.fire(
                    error.error?.title,
                    error.error?.message,
                    'info'
                );
                window.scrollTo(0, 0);
                this.router.navigate(['/inicio']);
            } else if (error.error?.message) {
                this.translate
                    .get('empresa.alertaError')
                    .subscribe((translatedText: string) => {
                        Swal.fire({
                            title: '',
                            html: translatedText,
                            icon: 'error',
                        });
                    });
            } else {
                Swal.fire(
                    'Error',
                    'Ocurrió un error al procesar la solicitud',
                    'error'
                );
            }
        }
    }

    /**
     * Determina si se debe mostrar la sección de eslabones secundarios ('Empacador', 'Envasador').
     *
     * Este getter se utiliza en la plantilla HTML para controlar la visibilidad de los eslabones
     * que son dependientes. La lógica devuelve `true` si el usuario ha seleccionado
     * al menos uno de los eslabones principales que habilitan a los secundarios:
     * 'Productor', 'Comercializador' o 'Importador'.
     *
     * @returns {boolean} Retorna `true` si se debe mostrar la sección de eslabones secundarios;
     * de lo contrario, retorna `false`.
     */
    get mostrarEslabonesSecundarios(): boolean {
        if (!this.selectedEslabon || this.selectedEslabon.length === 0) {
            return false;
        }
        return (
            this.selectedEslabon.includes('Productor') ||
            this.selectedEslabon.includes('Comercializador') ||
            this.selectedEslabon.includes('Importador')
        );
    }

    /**
     * Muestra una ventana emergente con información de ayuda sobre la selección de eslabones.
     *
     * @returns {void} No retorna ningún valor.
     */
    mostrarTooltipEslabon() {
        this.translate
            .get('empresa.infoEslabones')
            .subscribe((translatedText: string) => {
                Swal.fire('', translatedText, 'info');
            });
    }

    submitForm() {
        this.dirUrbana.submitFormUr();
        this.empresa = this.empresaForm.value;
        this.empresa.representante_agente_vigilado_id =
            this.empresaService.representanteId();
        if (this.empresaForm.valid) {
            /* validacion si no existe datos en formulario hijo */
            if (this.direccionUrbanahijo !== undefined) {
                {
                    this.empresaForm.patchValue({
                        direccion: this.direccionUrbanahijo,
                    });
                    this.empresa = this.empresaForm.value;
                }
                const nitValue = this.empresaForm.get('nit').value.toString();
                this.empresa.nit = nitValue;
                console.dir(this.empresa);
                this.postEmpresa(this.empresa);
            }
        } else {
            this.empresaForm.markAllAsTouched();
            console.log('ocurrió un error');
        }
    }

    /* refactorizar */
    addProducto(value: string): void {
        event.preventDefault();
        this.selectedProductos = this.empresaHelper.addProducto(
            value,
            this.empresaForm
        );
        this.updateEslabonOptions();
    }

    removeProducto(value: string): void {
        event.preventDefault();
        this.selectedProductos = this.empresaHelper.removeProducto(
            value,
            this.empresaForm
        );
        this.updateEslabonOptions();
    }

    addEslabon(value: string): void {
        event.preventDefault();
        this.selectedEslabon = this.empresaHelper.addEslabon(
            value,
            this.empresaForm
        );
    }

    removeEslabon(value: string): void {
        event.preventDefault();

        const index = this.selectedEslabon.indexOf(value);
        if (index > -1) {
            this.selectedEslabon.splice(index, 1);
        }

        if (
            value === 'Productor' ||
            value === 'Importador' ||
            value === 'Comercializador'
        ) {
            if (
                !this.selectedEslabon.includes('Productor') &&
                !this.selectedEslabon.includes('Importador') &&
                !this.selectedEslabon.includes('Comercializador')
            ) {
                this.removeEslabonSiExiste('Empacador');
                this.removeEslabonSiExiste('Envasador');
            }
        }

        this.empresaForm
            .get('eslabon')
            .setValue(this.selectedEslabon.join('/'));
    }

    private removeEslabonSiExiste(eslabon: string): void {
        const index = this.selectedEslabon.indexOf(eslabon);
        if (index > -1) {
            this.selectedEslabon.splice(index, 1);
        }
    }

    private updateEslabonOptions(): void {
        if (
            this.selectedProductos.length === 1 &&
            this.selectedProductos[0] === 'Alimentos balanceados'
        ) {
            this.opcionesEslabon = [
                'Productor',
                'Importador',
                'Comercializador',
            ];
            this.selectedEslabon.forEach((eslabon) => {
                if (eslabon === 'Empacador' || eslabon === 'Envasador') {
                    this.selectedEslabon = this.empresaHelper.removeEslabon(
                        eslabon,
                        this.empresaForm
                    );
                }
            });
        } else {
            this.opcionesEslabon = [
                'Productor',
                'Importador',
                'Comercializador',
                'Empacador',
                'Envasador',
            ];
        }
    }
}
